export default __webpack_public_path__ + "static/media/emission.a70cedd1.png";